import { call, put, takeEvery } from "redux-saga/effects";
import { lopBanApi } from "../../../api/category/lopBanApi";
import { ILopBan } from "../../../model/respone/category/ILopBan";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eLopBanActionIds,
  ILopBanActionTypes,
} from "../../action-types/category/ILopBanActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.lopBan;

export function* lopBanSaga(): any {
  yield takeEvery(eLopBanActionIds.LOAD_START, loadWorker);
  yield takeEvery(eLopBanActionIds.SAVE_START, saveWorker);
  yield takeEvery(eLopBanActionIds.DELETE_START, deleteWorker);
}
function* loadWorker(): any {
  const res: IBaseRespone = yield call(lopBanApi.SelectAll);
  if (res.is_success) yield put(mainAction.LOAD_SUCCESS(res.data));
  else yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
}
function* saveWorker(action: ILopBanActionTypes): any {
  const payload = action.payload as ILopBan;
  const res: IBaseRespone = payload.id > 0
    ? yield call(lopBanApi.Update, payload)
    : yield call(lopBanApi.Insert, payload);
  if (res.is_success) yield put(mainAction.SAVE_SUCCESS(res.data));
  else yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
}
function* deleteWorker(action: ILopBanActionTypes): any {
  const res: IBaseRespone = yield call(lopBanApi.Delete, action.payload as number);
  if (res.is_success) yield put(mainAction.DELETE_SUCCESS(res.data));
  else yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
}
